module.exports = __webpack_public_path__ + "static/media/background4.d59a3dcb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/background4.jpg
// module id = 260
// module chunks = 0